/**
 * brand-section.js
 *
 * Initialises the Swiper carousel for every .brand-section on the page.
 * Swiper core is loaded from CDN via the liquid template (see brand-section.liquid).
 *
 * Load with:
 *   <script src="{{ 'brand-section.js' | asset_url }}" defer></script>
 *   (place AFTER the Swiper CDN <script> tag so Swiper is defined when this runs)
 *
 * CWV notes
 *  – Deferred: zero render-blocking.
 *  – Autoplay uses requestAnimationFrame internally (Swiper default); no manual
 *    timers added here.
 *  – loop:true requires Swiper to clone slides; loopedSlides is set
 *    automatically when slidesPerView is 'auto'.
 *  – Each section gets its own Swiper instance scoped by its unique wrapper ID,
 *    so multiple brand sections on one page work independently.
 */

(function () {
  'use strict';

  function initBrandSwiper(wrapper) {
    /* Safety: do nothing if Swiper isn't on the page */
    if (typeof Swiper === 'undefined') {
      console.warn('brand-section.js: Swiper is not loaded.');
      return;
    }

    new Swiper(wrapper, {
      /* Slide width is determined by the slide content (brand image) */
      slidesPerView : 'auto',
      spaceBetween  : 32,
      loop          : true,

      /* Continuous autoplay – pauses on hover for accessibility */
      autoplay: {
        delay               : 0,          /* 0 = continuous scroll */
        disableOnInteraction: false,
        pauseOnMouseEnter   : true
      },
      speed: 3000,                         /* ms per full slide width */

      /* No pagination or arrows needed for a logo strip */
      grabCursor: true,

      /* Accessibility */
      a11y: {
        enabled: true
      },

      breakpoints: {
        0: {
          spaceBetween: 20
        },
        750: {
          spaceBetween: 32
        },
        1024: {
          spaceBetween: 48
        }
      }
    });
  }

  function init() {
    document
      .querySelectorAll('.brand-section .brand-wrapper')
      .forEach(initBrandSwiper);
  }

  /* Wait for DOMContentLoaded; if Swiper CDN is async it may arrive later,
     so we also listen for the window load event as a fallback. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());